/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";

import React from "react";

import { useState, useEffect } from "react";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import { Typography } from "@material-ui/core";

import { CrossWrap } from "../tools/Size";

import { useStoreon } from "storeon/react";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import RadiusManager from "components/RadiusManager";

const RowWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled(Typography)`
  color: white;
  margin-top: 15px;
  margin-bottom: 10px;
`;

const Input = styled(TextField)`
  width: 147px;
  > div {
    background: white;
    padding-left: 10px;
    > div > p {
      margin-right: 7px;
      color: #666;
    }
  }
`;

const CMInput = (props) => {
  const adornmentText = props.adornmentText ? props.adornmentText : "cm";
  return (
    <Input
      type="number"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment variant="filled" position="end">
            {adornmentText}
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};

const defaultSettings = {
  cutSize: 3,
  cutEnabled: true,
  minWidth: 10,
  minHeight: 10,
  maxWidth: 300,
  maxHeight: 300,
  minDPI: 80,
  isDynamicSize: true,
  isDynamicRadius: true,
  minRadius: 1,
  maxRadius: 100,
};

const EditorSettings = (props) => {
  const { canvas, id } = useStoreon("canvas", "id");

  const [settings, setSettings] = useState(defaultSettings);
  const [errors, setErrors] = useState({});

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setSettings((settings) => {
      settings[name] = checked;
      updateCanvasSettings(settings);
      return { ...settings };
    });
  };

  const updateCanvasSettings = (settings) => {
    Object.keys(settings).forEach((option) => {
      if (!errors[option]) {
        canvas.settings[option] = settings[option];
      }
    });
  };

  useEffect(
    (_) => {
      if (canvas?.settings) {
        setSettings({ ...defaultSettings, ...canvas.settings });
      } else {
        setSettings(defaultSettings);
      }
    },
    [canvas, id]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numVal = parseFloat(value, 10);
    setSettings((settings) => {
      settings[name] = numVal;
      updateCanvasSettings(settings);
      return { ...settings };
    });

    if (numVal < 1 || numVal > 1000) {
      setErrors((e) => {
        e[name] = true;
        return { ...e };
      });
    } else {
      setErrors((e) => {
        e[name] = false;
        return { ...e };
      });
    }
  };
  return (
    <React.Fragment>
      <Title variant="subtitle2">Editor settings:</Title>
      <FormControlLabel
        control={
          <Switch
            checked={settings.cutEnabled}
            name="cutEnabled"
            onChange={handleSwitchChange}
            value="checkedB"
          />
        }
        label="Cut line"
      />
      <br />
      {settings.cutEnabled && (
        <CMInput
          label="Cut size"
          fullWidth
          error={errors.cutSize}
          value={settings.cutSize}
          name="cutSize"
          adornmentText="mm"
          onChange={handleChange}
        />
      )}
      <br />
      <br />
      <CMInput
        label="Min. DPI"
        fullWidth
        error={errors.minDPI}
        value={settings.minDPI}
        name="minDPI"
        onChange={handleChange}
      />
      <br />
      <br />
      <FormControlLabel
        control={
          <Switch
            checked={settings.isDynamicSize}
            name="isDynamicSize"
            onChange={handleSwitchChange}
            value="checkedA"
          />
        }
        label="Dynamic size"
      />
      {settings.isDynamicSize && (
        <React.Fragment>
          <RowWrap>
            <CMInput
              label="Min. width"
              onChange={handleChange}
              name="minWidth"
              error={errors.minWidth}
              value={settings["minWidth"]}
            />
            <CrossWrap>x</CrossWrap>
            <CMInput
              label="Min. height"
              name="minHeight"
              error={errors.minHeight}
              value={settings.minHeight}
              onChange={handleChange}
            />
          </RowWrap>
          <RowWrap>
            <CMInput
              label="Max. width"
              onChange={handleChange}
              name="maxWidth"
              error={errors.maxWidth}
              value={settings["maxWidth"]}
            />

            <CrossWrap>x</CrossWrap>

            <CMInput
              label="Max. height"
              name="maxHeight"
              error={errors.maxHeight}
              value={settings.maxHeight}
              onChange={handleChange}
            />
          </RowWrap>
        </React.Fragment>
      )}
      <FormControlLabel
        control={
          <Switch
            checked={settings.isDynamicRadius}
            name="isDynamicRadius"
            onChange={handleSwitchChange}
          />
        }
        label="Dynamic radius"
      />
      {settings.isDynamicRadius && (
        <>
          <RowWrap>
            <CMInput
              label="Min. radius"
              onChange={handleChange}
              name="minRadius"
              error={errors.minRadius}
              value={settings.minRadius}
            />
            <CrossWrap>x</CrossWrap>
            <CMInput
              label="Max. radius"
              name="maxRadius"
              error={errors.maxRadius}
              value={settings.maxRadius}
              onChange={handleChange}
            />
          </RowWrap>
        </>
      )}
    </React.Fragment>
  );
};

export default EditorSettings;
